import React, { useEffect } from 'react';
import { URL_ROOM_ID_KEY } from '../../../../utils/property/propertyUtils';
import MainRoomInfo from './MainRoomInfo';
import Occupancy from './Occupancy';
import Beds from './Beds';
import RoomImagesList from '../images/RoomImagesList';
import useEncodedUrlId from '../../../../customHooks/useEncodedUrlId';
import {
    usePropertyComplementaryData,
    usePropertyProgress,
    usePropertyRoomDetail,
} from '../../../contextsProperty/ContextProperties';
import RoomServices from './RoomServices';

const SingleRoom = () => {
    const { handleTargetRoom, roomsLoaded } = usePropertyRoomDetail();
    const { getRoomsSectionData } = usePropertyComplementaryData();

    const idRoom = useEncodedUrlId(URL_ROOM_ID_KEY);

    useEffect(() => {
        if (idRoom && roomsLoaded) {
            handleTargetRoom(idRoom);
            getRoomsSectionData();
        }
    }, [idRoom, roomsLoaded]);

    useEffect(() => {
        return () => {
            handleTargetRoom();
        };
    }, []);

    const { activeTab } = usePropertyProgress();

    const getCurrentForm = () => {
        switch (activeTab) {
            case 1:
            default:
                return <MainRoomInfo />;
            case 2:
                return <Occupancy />;
            case 3:
                return <RoomServices />;
            case 4:
                return <Beds />;
            case 5:
                return <RoomImagesList />;
        }
    };

    return <>{getCurrentForm()}</>;
};

export default SingleRoom;
